"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = exports.EventsCalendarWidget = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _EventCalendarRow = _interopRequireDefault(require("./EventCalendarRow"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _zod = require("zod");

var _widgetContainer = _interopRequireWildcard(require("../widget-container"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'event_calendar';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-event_calendar';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  amount: _zod.z.number()
}).merge(_widgetContainer.widgetContainerConfig);

exports.config = config;

var EventsCalendarWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventsCalendarWidget, _Component);

  var _super = _createSuper(EventsCalendarWidget);

  function EventsCalendarWidget(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EventsCalendarWidget);
    _this = _super.call(this, props);
    _this.state = {
      eventsList: props.eventsList || [],
      isLoading: false
    };
    return _this;
  }

  (0, _createClass2.default)(EventsCalendarWidget, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.state.eventsList.length) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.setState({
                  isLoading: true
                });
                _context.prev = 3;
                _context.next = 6;
                return _axios.default.get('/widget/eventsCalendar', {
                  params: {
                    maxResults: this.props.config.amount
                  }
                });

              case 6:
                res = _context.sent;

                if (res.data) {
                  this.setState({
                    eventsList: res.data,
                    isLoading: false
                  });
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                this.setState({
                  isLoading: false
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var config = this.props.config;
      var _this$state = this.state,
          eventsList = _this$state.eventsList,
          isLoading = _this$state.isLoading;
      var eventsCount = eventsList.length;
      var showTwoColumns = eventsCount === 4 || eventsCount === 2;
      return (0, _preact.h)(_widgetContainer.default, {
        config: config,
        widgetName: "event-calendar"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('full-width', 'Template-brand-featured', 'homepage-widget-wrapper', 'custom-event-calendar', 'widget', 'widget--event-calendar', 'qa-widget-event_calendar')
      }, (0, _preact.h)("div", {
        className: "sitewidth"
      }, (0, _preact.h)("div", {
        className: "col event-calendar-container"
      }, !isLoading && eventsCount > 0 && (0, _preact.h)("div", {
        className: "event-calendar-wrapper ".concat(showTwoColumns ? 'event-calendar-wrapper-two-column' : 'event-calendar-wrapper-three-column')
      }, eventsList.map(function (event) {
        return (0, _preact.h)(_EventCalendarRow.default, (0, _extends2.default)({
          key: event.id
        }, event));
      })), !isLoading && eventsCount > 0 && (0, _preact.h)("div", null, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/events"),
        className: "btn--cta btn--show-more"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.show.more",
        m: "Forum"
      })))))));
    }
  }]);
  return EventsCalendarWidget;
}(_preact.Component);

exports.EventsCalendarWidget = EventsCalendarWidget;
var _default = EventsCalendarWidget;
exports.default = _default;